export const SESSION_STORAGE_KEY_HAS_VIEWED_LOGIN_PROMPT = 'hasViewedLoginPrompt';
export const SESSION_COOKIE_EXPIRY_DURATION_IN_DAYS = +(process.env.SESSION_COOKIE_EXPIRY_DURATION_IN_DAYS ?? 1);
